// extracted by mini-css-extract-plugin
export default {"scope":"-jW9J","scope--direction-x":"_7cV+u","scope--has-content-items":"ZsT-Q","scope--direction-y":"zZnzj"};